import React from "react";
import Helmet from "react-helmet";
import HeaderImage from "../components/HeaderImage/HeaderImage";
import VideoTypes from "../components/VideoTypes/VideoTypes";

const VideosByTypePage = ({
  data: {
    allMarkdownRemark: {
      group
    },
    videosHeaderImage
  }
}) => {

  // filter by era client side since apparently you can't filter
  // graphql queries with substrings in arrays?
  const TypeTags = group.filter(x => !x.fieldValue.toLowerCase().includes("era"));

  return (
    <div>
      <Helmet title="Videos By Type" />
      <HeaderImage headerImage={videosHeaderImage} />
      <div className="section">
        <div className="container" style={{paddingTop: "100px"}}>
          <h1 className="title is-1">
            Videos By Type
          </h1>
          <VideoTypes tags={TypeTags} />
        </div>
      </div>
    </div>
  );
};

export default VideosByTypePage;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query TagsTypeQuery {
    allMarkdownRemark(
      limit: 2000
      filter: {frontmatter: {category: {eq: "video"}}}
    ) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
    videosHeaderImage: file(relativePath: { eq: "bg/subbed_videos.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 1920) {
          ...GatsbyImageSharpSizes
        }
      }
    }
  }
`;




// WEBPACK FOOTER //
// ./src/pages/videos-by-type.jsx